import { Stack } from '@etg/wings';
import { addAislesToColumnDetails, addAislesToRows, addExitRows, isEmptyRow, isExitRow, isRowOverWing } from '../utils/layout';
import ColumnDetails from './rowsandcolums/ColumnDetails';
import Row from './rowsandcolums/Row';
import RowContent from './rowsandcolums/RowContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const generateKey = index => `row_${index}`;
const SeatMapCabin = _ref => {
  let {
    activeSegment,
    carrier,
    sellSeatMapColumnDetails = [],
    onChange,
    rows = [],
    seatTravelers
  } = _ref;
  const columnsWithAisles = addAislesToColumnDetails(sellSeatMapColumnDetails);
  const rowsWithAisles = addAislesToRows(rows, columnsWithAisles);
  const transformedRowData = addExitRows(rowsWithAisles);
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: 0,
    children: [/*#__PURE__*/_jsx(ColumnDetails, {
      details: columnsWithAisles,
      isOverWing: transformedRowData !== null && transformedRowData !== void 0 && transformedRowData[0] ? isRowOverWing(transformedRowData[0]) : false
    }), transformedRowData === null || transformedRowData === void 0 ? void 0 : transformedRowData.map((row, index) => /*#__PURE__*/_jsx(Row, {
      isEmptyRow: isEmptyRow(row),
      isOverWing: isRowOverWing(row),
      children: /*#__PURE__*/_jsx(RowContent, {
        activeSegment: activeSegment,
        carrier: carrier,
        isEmptyRow: isEmptyRow(row),
        isExitRow: isExitRow(row),
        onChange: onChange,
        seatTravelers: seatTravelers,
        sellSeatMapSeats: row.sellSeatMapSeats
      })
    }, generateKey(index)))]
  });
};
export default SeatMapCabin;
//# sourceMappingURL=SeatMapCabin.js.map